import { render, staticRenderFns } from "./BookingHotel.vue?vue&type=template&id=acfd32fa&scoped=true"
import script from "./BookingHotel.vue?vue&type=script&lang=js"
export * from "./BookingHotel.vue?vue&type=script&lang=js"
import style0 from "./BookingHotel.vue?vue&type=style&index=0&id=acfd32fa&prod&lang=css"
import style1 from "./BookingHotel.vue?vue&type=style&index=1&id=acfd32fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfd32fa",
  null
  
)

export default component.exports